import { useCallback, useState } from 'react';

/**
 * Melyik verzió újdonságait látta már ez a gép.
 *
 * Gépenkénti kényelmi adat (localStorage): ha elveszik, legfeljebb újra
 * megjelenik a pötty a verziószám mellett - semmi más nem múlik rajta.
 */
const KEY = 'avslack.seenVersion';

function readSeen(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function useSeenVersion(): [string | null, () => void] {
  const [seen, setSeen] = useState(readSeen);
  const markSeen = useCallback(() => {
    try {
      localStorage.setItem(KEY, __APP_VERSION__);
    } catch {
      // privát ablak / letiltott tároló - a pötty marad, ennyi
    }
    setSeen(__APP_VERSION__);
  }, []);
  return [seen, markSeen];
}
